(function () {

  if (window.__NB_SUBSCRIPTION_GIFTS_V6_INITIALIZED__) return;

  window.__NB_SUBSCRIPTION_GIFTS_V6_INITIALIZED__ = true;

  /*

   * ============================================================

   * NEUROBROCC SUBSCRIPTION GIFTS — V6

   * ONE-REQUEST NESTED CART ENGINE

   * ============================================================

   *

   * PRIMARY FLOW

   *

   * Parent subscription + 3 nested gifts

   * are added in ONE /cart/add.js request.

   *

   * BACKUP FLOW

   *

   * If an app/button bypasses our one-request interception,

   * reconciliation repairs the Shopify cart afterward.

   *

   * APPEARANCE

   *

   * cart-item.liquid controls gift appearance.

   * This file does NOT build or hide gift UI.

   * ============================================================

   */

  const CONFIG = {

    sellingPlanIds: [
      25833308980,
      24552080180,
      23563797300
    ],

    gifts: [

      {

        id: 42052454088786,

        name: 'Travel Pill Case'

      },

      {

        id: 42052451598418,

        name: 'Glass Jar'

      },

      {

        id: 42632790704210,

        name: 'Mystery Gift'

      }

    ],

    /*

     * Shopify bundled section rendering.

     *

     * If our one-request interception succeeds, Shopify can return

     * the updated Shapes cart markup with the SAME add request.

     */

    sections: [

      'cart-items',

      'cart-footer',

      'cart-item-count',

      'cart-live-region'

    ],

    debug: true

  };

  const GIFT_IDS = CONFIG.gifts.map(function (gift) {

    return Number(gift.id);

  });

  /*

   * Save the fetch implementation that existed before this script.

   */

  const nativeFetch = window.fetch.bind(window);

  const shopifyRoot =

    window.Shopify &&

    window.Shopify.routes &&

    window.Shopify.routes.root

      ? window.Shopify.routes.root

      : '/';

  const ROOT = shopifyRoot.endsWith('/')

    ? shopifyRoot

    : shopifyRoot + '/';

  /*

   * ============================================================

   * STATE

   * ============================================================

   */

  let cachedCart = null;

  let syncPromise = null;

  let syncRequestedAgain = false;

  let syncTimer = null;

  /*

   * ============================================================

   * LOGGING

   * ============================================================

   */

  function log() {

    if (!CONFIG.debug) return;

    const args = Array.prototype.slice.call(arguments);

    args.unshift(

      '[NB Subscription Gifts V6]'

    );

    console.log.apply(

      console,

      args

    );

  }

  function warn() {

    const args = Array.prototype.slice.call(arguments);

    args.unshift(

      '[NB Subscription Gifts V6]'

    );

    console.warn.apply(

      console,

      args

    );

  }

  function error() {

    const args = Array.prototype.slice.call(arguments);

    args.unshift(

      '[NB Subscription Gifts V6]'

    );

    console.error.apply(

      console,

      args

    );

  }

  function sleep(ms) {

    return new Promise(function (resolve) {

      setTimeout(resolve, ms);

    });

  }

  /*

   * ============================================================

   * REQUEST HELPERS

   * ============================================================

   */

  function getRequestUrl(input) {

    if (typeof input === 'string') {

      return input;

    }

    if (

      input &&

      typeof input.url === 'string'

    ) {

      return input.url;

    }

    return '';

  }

  function getRequestMethod(

    input,

    init

  ) {

    if (

      init &&

      init.method

    ) {

      return String(

        init.method

      ).toUpperCase();

    }

    if (

      input &&

      input.method

    ) {

      return String(

        input.method

      ).toUpperCase();

    }

    return 'GET';

  }

  function cleanUrl(url) {

    return String(

      url || ''

    ).split('?')[0];

  }

  function isCartAddUrl(url) {

    const clean =

      cleanUrl(url);

    return (

      clean.endsWith(

        '/cart/add.js'

      ) ||

      clean.includes(

        '/cart/add.js'

      )

    );

  }

  function isCartMutationUrl(url) {

    const clean =

      cleanUrl(url);

    return (

      clean.includes(

        '/cart/add.js'

      ) ||

      clean.includes(

        '/cart/change.js'

      ) ||

      clean.includes(

        '/cart/update.js'

      ) ||

      clean.includes(

        '/cart/clear.js'

      )

    );

  }

  /*

   * ============================================================

   * SHOPIFY CART

   * ============================================================

   */

  async function getCart() {

    const response =

      await nativeFetch(

        ROOT + 'cart.js',

        {

          method: 'GET',

          headers: {

            Accept:

              'application/json'

          },

          credentials:

            'same-origin'

        }

      );

    if (!response.ok) {

      throw new Error(

        'Unable to fetch Shopify cart.'

      );

    }

    cachedCart =

      await response.json();

    return cachedCart;

  }

  /*

   * Prime cart state immediately.

   *

   * This normally completes long before the customer clicks ATC.

   */

  getCart().catch(function () {

    /*

     * Non-fatal.

     */

  });

  /*

   * ============================================================

   * CART ITEM HELPERS

   * ============================================================

   */

  function getSellingPlanId(item) {

    if (!item) return null;

    if (

      item.selling_plan_allocation &&

      item.selling_plan_allocation

        .selling_plan &&

      item.selling_plan_allocation

        .selling_plan.id

    ) {

      return Number(

        item.selling_plan_allocation

          .selling_plan.id

      );

    }

    if (

      item.selling_plan_allocation &&

      item.selling_plan_allocation

        .selling_plan_id

    ) {

      return Number(

        item.selling_plan_allocation

          .selling_plan_id

      );

    }

    if (item.selling_plan) {

      return Number(

        item.selling_plan

      );

    }

    if (item.selling_plan_id) {

      return Number(

        item.selling_plan_id

      );

    }

    return null;

  }

  function isGift(item) {

    if (!item) return false;

    const variantId =

      Number(

        item.variant_id ||

        item.id

      );

    return GIFT_IDS.includes(

      variantId

    );

  }

  function isEligibleSubscription(

    item

  ) {

    if (!item) return false;

    if (isGift(item)) {

      return false;

    }

    return CONFIG.sellingPlanIds.includes(
      Number(getSellingPlanId(item))
    );

  }

  function findEligibleParent(cart) {

    if (

      !cart ||

      !Array.isArray(

        cart.items

      )

    ) {

      return null;

    }

    return (

      cart.items.find(

        function (item) {

          return (

            isEligibleSubscription(

              item

            )

          );

        }

      ) || null

    );

  }

  function getGiftLines(cart) {

    if (

      !cart ||

      !Array.isArray(

        cart.items

      )

    ) {

      return [];

    }

    return cart.items.filter(

      function (item) {

        return isGift(item);

      }

    );

  }

  function getParentKey(item) {

    if (

      !item ||

      !item.parent_relationship ||

      !item.parent_relationship

        .parent_key

    ) {

      return null;

    }

    return item

      .parent_relationship

      .parent_key;

  }

  function hasGiftProperty(item) {

    return !!(

      item &&

      item.properties &&

      String(

        item.properties[

          '_nb_subscription_gift'

        ]

      ) === 'true'

    );

  }

  /*

   * ============================================================

   * VERIFY CURRENT CART

   * ============================================================

   */

  function giftStateIsCorrect(

    cart,

    parentKey

  ) {

    const giftLines =

      getGiftLines(cart);

    if (

      giftLines.length !==

      CONFIG.gifts.length

    ) {

      return false;

    }

    for (

      const gift

      of CONFIG.gifts

    ) {

      const matches =

        giftLines.filter(

          function (item) {

            return (

              Number(

                item.variant_id

              ) ===

              Number(

                gift.id

              )

            );

          }

        );

      /*

       * Exactly one of each gift.

       */

      if (

        matches.length !== 1

      ) {

        return false;

      }

      const item =

        matches[0];

      /*

       * Gift quantity never follows parent qty.

       */

      if (

        Number(

          item.quantity

        ) !== 1

      ) {

        return false;

      }

      /*

       * Must be nested under the correct parent.

       */

      if (

        getParentKey(item) !==

        parentKey

      ) {

        return false;

      }

      /*

       * This property allows cart-item.liquid to use the

       * special Auri-style gift template.

       */

      if (

        !hasGiftProperty(item)

      ) {

        return false;

      }

    }

    return true;

  }

  /*

   * ============================================================

   * DOES THE CART ALREADY HAVE OUR GIFT SET?

   * ============================================================

   */

  function cachedCartAlreadyHasGifts() {

    if (!cachedCart) {

      return false;

    }

    const parent =

      findEligibleParent(

        cachedCart

      );

    const gifts =

      getGiftLines(

        cachedCart

      );

    /*

     * If any gift already exists, don't append a second set

     * to the incoming ATC request.

     *

     * Backup reconciliation will repair partial/incorrect sets.

     */

    return !!(

      parent &&

      gifts.length

    );

  }

  /*

   * ============================================================

   * BUILD NESTED CHILD ITEMS FOR SAME REQUEST

   * ============================================================

   */

  function buildNestedGiftItems(

    parentVariantId

  ) {

    return CONFIG.gifts.map(

      function (gift) {

        return {

          id: Number(

            gift.id

          ),

          quantity: 1,

          /*

           * IMPORTANT:

           *

           * parent_id is used because parent and children

           * are being added TOGETHER in the same request.

           */

          parent_id:

            Number(

              parentVariantId

            ),

          properties: {

            _nb_subscription_gift:

              'true'

          }

        };

      }

    );

  }

  /*

   * ============================================================

   * BUNDLED SECTION RENDERING

   * ============================================================

   */

  function addSectionRendering(

    payload

  ) {

    if (!payload) {

      return payload;

    }

    /*

     * Respect another app if it already requested its own sections.

     */

    if (!payload.sections) {

      payload.sections =

        CONFIG.sections.join(

          ','

        );

    }

    if (

      !payload.sections_url

    ) {

      payload.sections_url =

        window.location.pathname ||

        '/';

    }

    return payload;

  }

  /*

   * ============================================================

   * TRANSFORM A MULTI-ITEM /cart/add.js PAYLOAD

   * ============================================================

   */

  function transformAddPayload(

    payload

  ) {

    if (

      !payload ||

      typeof payload !==

        'object'

    ) {

      return {

        transformed: false,

        payload: payload

      };

    }

    /*

     * V6 intentionally targets Shopify's recommended

     * multi-item format:

     *

     * {

     *   items: [...]

     * }

     */

    if (

      !Array.isArray(

        payload.items

      )

    ) {

      return {

        transformed: false,

        payload: payload,

        reason:

          'legacy-single-item-format'

      };

    }

    /*

     * Find eligible subscription inside this EXACT add request.

     */

    const eligibleParent =

      payload.items.find(

        function (item) {

          return (

            isEligibleSubscription(

              item

            )

          );

        }

      );

    if (!eligibleParent) {

      return {

        transformed: false,

        payload: payload,

        reason:

          'not-eligible'

      };

    }

    const parentVariantId =

      Number(

        eligibleParent.id

      );

    if (!parentVariantId) {

      return {

        transformed: false,

        payload: payload,

        reason:

          'missing-parent-id'

      };

    }

    /*

     * If the app already included one of our gifts, don't interfere.

     */

    const requestAlreadyHasGift =

      payload.items.some(

        function (item) {

          return GIFT_IDS.includes(

            Number(

              item.id

            )

          );

        }

      );

    if (

      requestAlreadyHasGift

    ) {

      log(

        'Incoming add request already contains gift variants. Leaving items unchanged.'

      );

      return {

        transformed: false,

        payload:

          addSectionRendering(

            payload

          ),

        reason:

          'gifts-already-in-request'

      };

    }

    /*

     * Customer already has our gift set.

     *

     * Example:

     * subscription qty 1 already in cart,

     * then they add another quantity.

     *

     * Do NOT add another set of gifts.

     */

    if (

      cachedCartAlreadyHasGifts()

    ) {

      log(

        'Existing cart already contains subscription gifts. Parent add will continue without duplicate gifts.'

      );

      return {

        transformed: false,

        payload:

          addSectionRendering(

            payload

          ),

        reason:

          'gift-set-already-present'

      };

    }

    /*

     * THIS IS THE IMPORTANT V6 STEP.

     *

     * Parent stays first.

     * Children are appended to the SAME request.

     */

    const nestedGifts =

      buildNestedGiftItems(

        parentVariantId

      );

    const transformedPayload =

      Object.assign(

        {},

        payload,

        {

          items:

            payload.items.concat(

              nestedGifts

            )

        }

      );

    addSectionRendering(

      transformedPayload

    );

    log(

      'ONE-REQUEST NESTED ADD ACTIVATED',

      {

        parentVariantId:

          parentVariantId,

        sellingPlanIds:
          CONFIG.sellingPlanIds,

        originalItems:

          payload.items,

        addedChildren:

          nestedGifts

      }

    );

    return {

      transformed: true,

      payload:

        transformedPayload,

      parentVariantId:

        parentVariantId

    };

  }

  /*

   * ============================================================

   * READ / REWRITE JSON FETCH REQUEST

   * ============================================================

   */

  async function maybeTransformCartAddRequest(

    input,

    init

  ) {

    const url =

      getRequestUrl(input);

    const method =

      getRequestMethod(

        input,

        init

      );

    if (

      method !== 'POST' ||

      !isCartAddUrl(url)

    ) {

      return null;

    }

    /*

     * ----------------------------------------------------------

     * CASE 1

     * fetch('/cart/add.js', { body: JSON.stringify(...) })

     * ----------------------------------------------------------

     */

    if (

      init &&

      typeof init.body ===

        'string'

    ) {

      let parsed;

      try {

        parsed =

          JSON.parse(

            init.body

          );

      } catch (e) {

        /*

         * Not JSON.

         */

        return null;

      }

      const result =

        transformAddPayload(

          parsed

        );

      /*

       * If this is the legacy single-item format, leave it alone.

       * The backup reconciliation system will still work.

       */

      if (

        result.reason ===

        'legacy-single-item-format'

      ) {

        log(

          'Eligible/unknown legacy cart add detected. Not rewriting that request format for safety.'

        );

        return null;

      }

      const newInit =

        Object.assign(

          {},

          init,

          {

            body:

              JSON.stringify(

                result.payload

              )

          }

        );

      const headers =

        new Headers(

          init.headers || {}

        );

      if (

        !headers.has(

          'Content-Type'

        )

      ) {

        headers.set(

          'Content-Type',

          'application/json'

        );

      }

      newInit.headers =

        headers;

      return {

        input: input,

        init: newInit,

        transformed:

          result.transformed

      };

    }

    /*

     * ----------------------------------------------------------

     * CASE 2

     * fetch(new Request(...JSON...))

     * ----------------------------------------------------------

     */

    if (

      typeof Request !==

        'undefined' &&

      input instanceof Request

    ) {

      const contentType =

        input.headers.get(

          'Content-Type'

        ) || '';

      if (

        !contentType.includes(

          'application/json'

        )

      ) {

        return null;

      }

      let text;

      try {

        text =

          await input

            .clone()

            .text();

      } catch (e) {

        return null;

      }

      let parsed;

      try {

        parsed =

          JSON.parse(text);

      } catch (e) {

        return null;

      }

      const result =

        transformAddPayload(

          parsed

        );

      if (

        result.reason ===

        'legacy-single-item-format'

      ) {

        return null;

      }

      const headers =

        new Headers(

          input.headers

        );

      headers.set(

        'Content-Type',

        'application/json'

      );

      const newRequest =

        new Request(

          input,

          {

            headers: headers,

            body:

              JSON.stringify(

                result.payload

              )

          }

        );

      return {

        input:

          newRequest,

        init:

          undefined,

        transformed:

          result.transformed

      };

    }

    /*

     * FormData and other request styles are left untouched.

     * Backup reconciliation still covers them.

     */

    return null;

  }

  /*

   * ============================================================

   * APPLY SHOPIFY SECTION HTML FROM THE SAME RESPONSE

   * ============================================================

   */

  function processBundledSections(

    response

  ) {

    if (

      !response ||

      !response.ok

    ) {

      return;

    }

    /*

     * Don't delay the original button.

     *

     * Parse a cloned response asynchronously.

     */

    response

      .clone()

      .json()

      .then(function (data) {

        if (

          !data ||

          !data.sections

        ) {

          return;

        }

        /*

         * Shapes already listens to this event.

         */

        document.dispatchEvent(

          new CustomEvent(

            'shapes:cart:update',

            {

              bubbles: true,

              detail: {

                response: {

                  sections:

                    data.sections

                }

              }

            }

          )

        );

        log(

          'Shapes cart updated using bundled sections from the SAME add request.'

        );

      })

      .catch(function () {

        /*

         * Non-fatal.

         */

      });

  }

  /*

   * ============================================================

   * GLOBAL FETCH INTERCEPTOR

   * ============================================================

   */

  window.fetch =

    async function (

      input,

      init

    ) {

      const originalUrl =

        getRequestUrl(input);

      /*

       * Try to rewrite eligible /cart/add.js before Shopify sees it.

       */

      let transformedRequest =

        null;

      try {

        transformedRequest =

          await maybeTransformCartAddRequest(

            input,

            init

          );

      } catch (

        transformError

      ) {

        error(

          'Request transformation failed. Original request will continue.',

          transformError

        );

      }

      const finalInput =

        transformedRequest

          ? transformedRequest.input

          : input;

      const finalInit =

        transformedRequest

          ? transformedRequest.init

          : init;

      /*

       * IMPORTANT:

       *

       * Replo / Shapes / custom button only receives a successful

       * response AFTER Shopify has processed the combined request.

       */

      const response =

        await nativeFetch(

          finalInput,

          finalInit

        );

      if (

        response &&

        response.ok &&

        isCartAddUrl(

          originalUrl

        )

      ) {

        /*

         * If we requested bundled sections, update drawer

         * without another section request.

         */

        processBundledSections(

          response

        );

      }

      if (

        response &&

        response.ok &&

        isCartMutationUrl(

          originalUrl

        )

      ) {

        /*

         * Backup verification only.

         *

         * This runs AFTER the original request and does not block

         * the button from receiving its response.

         */

        scheduleSync(30);

      }

      return response;

    };

  /*

   * ============================================================

   * REMOVE GIFT LINES — BACKUP REPAIR

   * ============================================================

   */

  async function removeAllGiftLines(

    cart

  ) {

    const giftLines =

      getGiftLines(cart);

    if (

      !giftLines.length

    ) {

      return false;

    }

    const updates = {};

    giftLines.forEach(

      function (item) {

        updates[

          item.key

        ] = 0;

      }

    );

    log(

      'Backup repair: removing incorrect/orphan gift lines.',

      updates

    );

    const response =

      await nativeFetch(

        ROOT +

          'cart/update.js',

        {

          method: 'POST',

          headers: {

            'Content-Type':

              'application/json',

            Accept:

              'application/json'

          },

          credentials:

            'same-origin',

          body:

            JSON.stringify({

              updates:

                updates

            })

        }

      );

    if (!response.ok) {

      const text =

        await response.text();

      throw new Error(

        'Unable to remove gift lines: ' +

          text

      );

    }

    return true;

  }

  /*

   * ============================================================

   * ATTACH CHILDREN TO EXISTING PARENT — BACKUP ONLY

   * ============================================================

   */

  async function addGiftsToExistingParent(

    parentLineKey

  ) {

    const items =

      CONFIG.gifts.map(

        function (gift) {

          return {

            id:

              Number(

                gift.id

              ),

            quantity: 1,

            /*

             * Existing parent = parent_line_key.

             */

            parent_line_key:

              parentLineKey,

            properties: {

              _nb_subscription_gift:

                'true'

            }

          };

        }

      );

    const response =

      await nativeFetch(

        ROOT +

          'cart/add.js',

        {

          method: 'POST',

          headers: {

            'Content-Type':

              'application/json',

            Accept:

              'application/json'

          },

          credentials:

            'same-origin',

          body:

            JSON.stringify({

              items:

                items,

              sections:

                CONFIG.sections.join(

                  ','

                ),

              sections_url:

                window.location.pathname ||

                '/'

            })

        }

      );

    if (!response.ok) {

      const text =

        await response.text();

      throw new Error(

        'Unable to repair subscription gifts: ' +

          text

      );

    }

    processBundledSections(

      response

    );

    return await response.json();

  }

  /*

   * ============================================================

   * FALLBACK SECTION REFRESH

   * ============================================================

   */

  async function refreshCartSections() {

    try {

      const response =

        await nativeFetch(

          window.location.pathname +

            '?sections=' +

            CONFIG.sections.join(

              ','

            )

        );

      if (!response.ok) {

        return;

      }

      const data =

        await response.json();

      if (!data.status) {

        document.dispatchEvent(

          new CustomEvent(

            'shapes:cart:update',

            {

              bubbles: true,

              detail: {

                response: {

                  sections:

                    data

                }

              }

            }

          )

        );

      }

    } catch (e) {

      error(

        'Fallback cart section refresh failed.',

        e

      );

    }

  }

  /*

   * ============================================================

   * BACKUP RECONCILIATION

   * ============================================================

   *

   * Normal V6 flow should already be correct.

   *

   * This handles:

   * - apps that don't use JSON /cart/add.js

   * - old existing carts

   * - missing gifts

   * - wrong parent relationship

   * - missing private gift property

   * - orphan gifts

   * ============================================================

   */

  async function performSync() {

    let cart =

      await getCart();

    let parent =

      findEligibleParent(

        cart

      );

    let giftLines =

      getGiftLines(

        cart

      );

    /*

     * ----------------------------------------------------------

     * NO ELIGIBLE PARENT

     * ----------------------------------------------------------

     */

    if (!parent) {

      if (

        !giftLines.length

      ) {

        return {

          changed: false,

          status:

            'cart-correct-no-parent'

        };

      }

      /*

       * Never allow orphan gifts.

       */

      await removeAllGiftLines(

        cart

      );

      cachedCart =

        await getCart();

      await refreshCartSections();

      return {

        changed: true,

        status:

          'orphan-gifts-removed'

      };

    }

    /*

     * ----------------------------------------------------------

     * EVERYTHING ALREADY CORRECT

     * ----------------------------------------------------------

     */

    if (

      giftStateIsCorrect(

        cart,

        parent.key

      )

    ) {

      log(

        'Verification complete: parent + nested gifts are correct.'

      );

      return {

        changed: false,

        status:

          'nested-gifts-correct'

      };

    }

    /*

     * ----------------------------------------------------------

     * INCORRECT / PARTIAL GIFT SET

     * ----------------------------------------------------------

     */

    if (

      giftLines.length

    ) {

      await removeAllGiftLines(

        cart

      );

      cart =

        await getCart();

      parent =

        findEligibleParent(

          cart

        );

      if (!parent) {

        await refreshCartSections();

        return {

          changed: true,

          status:

            'parent-disappeared'

        };

      }

    }

    /*

     * App/button didn't get caught by one-request interception.

     *

     * Repair using existing parent line key.

     */

    warn(

      'One-request nested add was not present. Running backup gift attachment.'

    );

    await addGiftsToExistingParent(

      parent.key

    );

    let verificationCart =

      await getCart();

    if (

      giftStateIsCorrect(

        verificationCart,

        parent.key

      )

    ) {

      log(

        'Backup repair succeeded.'

      );

      return {

        changed: true,

        status:

          'backup-repair-success'

      };

    }

    /*

     * Retry once.

     */

    warn(

      'Backup verification failed. Retrying once.'

    );

    await removeAllGiftLines(

      verificationCart

    );

    await sleep(100);

    cart =

      await getCart();

    parent =

      findEligibleParent(

        cart

      );

    if (!parent) {

      await refreshCartSections();

      return {

        changed: true,

        status:

          'parent-disappeared'

      };

    }

    await addGiftsToExistingParent(

      parent.key

    );

    verificationCart =

      await getCart();

    if (

      giftStateIsCorrect(

        verificationCart,

        parent.key

      )

    ) {

      log(

        'Backup retry succeeded.'

      );

      return {

        changed: true,

        status:

          'backup-retry-success'

      };

    }

    /*

     * Final fail-safe:

     * no loose/free variants.

     */

    await removeAllGiftLines(

      verificationCart

    );

    cachedCart =

      await getCart();

    await refreshCartSections();

    throw new Error(

      'Nested gift relationship could not be verified.'

    );

  }

  /*

   * ============================================================

   * GUARANTEED SYNC QUEUE

   * ============================================================

   */

  async function syncNow() {

    if (syncPromise) {

      syncRequestedAgain =

        true;

      return syncPromise;

    }

    syncRequestedAgain =

      false;

    syncPromise =

      performSync()

        .catch(

          function (

            syncError

          ) {

            error(

              'Gift reconciliation failed.',

              syncError

            );

            return {

              changed: false,

              status:

                'error',

              error:

                syncError

            };

          }

        )

        .finally(

          function () {

            syncPromise =

              null;

            if (

              syncRequestedAgain

            ) {

              syncRequestedAgain =

                false;

              setTimeout(

                function () {

                  syncNow();

                },

                0

              );

            }

          }

        );

    return syncPromise;

  }

  function scheduleSync(delay) {

    if (syncPromise) {

      syncRequestedAgain =

        true;

    }

    clearTimeout(

      syncTimer

    );

    syncTimer =

      setTimeout(

        function () {

          syncNow();

        },

        typeof delay ===

          'number'

          ? delay

          : 0

      );

  }

  /*

   * ============================================================

   * SHOPIFY ACCELERATED CHECKOUT SUPPORT

   * ============================================================

   *

   * Shopify's native accelerated checkout buttons can use:

   *

   * shopify-additional-items[index][id]

   * shopify-additional-items[index][quantity]

   * shopify-additional-items[index][parent_id]

   *

   * These are only injected into product forms that actually

   * contain a Shopify accelerated checkout button.

   * ============================================================

   */

  function getFormSellingPlanId(

    form

  ) {

    if (!form) {

      return null;

    }

    /*

     * Checked radio first.

     */

    const checked =

      form.querySelector(

        '[name="selling_plan"]:checked'

      );

    if (

      checked &&

      checked.value

    ) {

      return Number(

        checked.value

      );

    }

    /*

     * Hidden/select fallback.

     */

    const field =

      form.querySelector(

        '[name="selling_plan"]'

      );

    if (

      field &&

      field.value

    ) {

      return Number(

        field.value

      );

    }

    return null;

  }

  function getFormVariantId(

    form

  ) {

    if (!form) {

      return null;

    }

    const checked =

      form.querySelector(

        '[name="id"]:checked'

      );

    if (

      checked &&

      checked.value

    ) {

      return Number(

        checked.value

      );

    }

    const field =

      form.querySelector(

        '[name="id"]'

      );

    if (

      field &&

      field.value

    ) {

      return Number(

        field.value

      );

    }

    return null;

  }

  function removeOurAcceleratedFields(

    form

  ) {

    if (!form) return;

    form

      .querySelectorAll(

        '.nb-subscription-gift-additional-item'

      )

      .forEach(

        function (field) {

          field.remove();

        }

      );

  }

  function addHiddenField(

    form,

    name,

    value

  ) {

    const input =

      document.createElement(

        'input'

      );

    input.type =

      'hidden';

    input.name =

      name;

    input.value =

      String(value);

    input.className =

      'nb-subscription-gift-additional-item';

    form.appendChild(

      input

    );

  }

  function updateAcceleratedCheckoutForm(

    form

  ) {

    if (!form) return;

    /*

     * Only touch forms containing Shopify accelerated checkout.

     */

    const acceleratedCheckout =

      form.querySelector(

        [

          '[data-shopify="payment-button"]',

          'shopify-accelerated-checkout'

        ].join(',')

      );

    if (

      !acceleratedCheckout

    ) {

      return;

    }

    removeOurAcceleratedFields(

      form

    );

    const sellingPlanId =

      getFormSellingPlanId(

        form

      );

    const parentVariantId =

      getFormVariantId(

        form

      );

    if (
      !CONFIG.sellingPlanIds.includes(
        Number(sellingPlanId)
      ) ||
      !parentVariantId
    ) {
      return;
    }

    CONFIG.gifts.forEach(

      function (

        gift,

        giftIndex

      ) {

        /*

         * Shopify additional item indexes begin at 1.

         */

        const index =

          giftIndex + 1;

        const prefix =

          'shopify-additional-items[' +

          index +

          ']';

        addHiddenField(

          form,

          prefix + '[id]',

          gift.id

        );

        addHiddenField(

          form,

          prefix +

            '[quantity]',

          1

        );

        addHiddenField(

          form,

          prefix +

            '[parent_id]',

          parentVariantId

        );

      }

    );

    log(

      'Native Shopify accelerated checkout configured with nested gift variants.',

      {

        parentVariantId:

          parentVariantId

      }

    );

  }

  function updateAllAcceleratedCheckoutForms() {

    document

      .querySelectorAll(

        'form[action*="/cart/add"]'

      )

      .forEach(

        function (form) {

          updateAcceleratedCheckoutForm(

            form

          );

        }

      );

  }

  /*

   * Subscription / variant changes.

   */

  document.addEventListener(

    'change',

    function () {

      requestAnimationFrame(

        updateAllAcceleratedCheckoutForms

      );

    },

    true

  );

  /*

   * Dynamic page builders may mount product forms later.

   */

  const formObserver =

    new MutationObserver(

      function () {

        updateAllAcceleratedCheckoutForms();

      }

    );

  /*

   * ============================================================

   * SHAPES / CART FALLBACK EVENTS

   * ============================================================

   */

  document.addEventListener(

    'shapes:cart:update',

    function () {

      /*

       * Don't immediately hammer Shopify.

       * Only verify shortly after Shapes finishes.

       */

      scheduleSync(80);

    }

  );

  /*

   * Cart quantity changes.

   */

  document.addEventListener(

    'change',

    function (

      event

    ) {

      const target =

        event.target;

      if (!target) return;

      const cartArea =

        target.closest(

          [

            '[data-cart-drawer]',

            '#cart',

            '.cart__contents'

          ].join(',')

        );

      if (!cartArea) {

        return;

      }

      scheduleSync(120);

    },

    true

  );

  /*

   * Browser BFCache.

   */

  window.addEventListener(

    'pageshow',

    function () {

      scheduleSync(100);

      updateAllAcceleratedCheckoutForms();

    }

  );

  /*

   * ============================================================

   * INITIALIZE

   * ============================================================

   */

  function initialize() {

    updateAllAcceleratedCheckoutForms();

    if (

      document.body

    ) {

      formObserver.observe(

        document.body,

        {

          childList: true,

          subtree: true

        }

      );

    }

    /*

     * Existing cart cleanup / verification.

     */

    scheduleSync(150);

  }

  if (

    document.readyState ===

    'loading'

  ) {

    document.addEventListener(

      'DOMContentLoaded',

      initialize

    );

  } else {

    initialize();

  }

  /*

   * ============================================================

   * DEBUG COMMANDS

   * ============================================================

   */

  window.NBSubscriptionGifts = {

    sync: syncNow,

    getCart: getCart,

    updateAcceleratedCheckoutForms:

      updateAllAcceleratedCheckoutForms,

    config:

      CONFIG

  };

  log(

    'V6 one-request nested gift engine initialized.'

  );

})();
